import {DurationUnit} from "../enums/durationUnit";
import {Month} from "../enums/month";
import {IDefaultVOption} from "../interfaces/vSelectInterfaces";
import {InstanceHelper} from "./instanceHelper";
import {AmPm} from "~/enums/AmPm";
import {Hash} from "~/interfaces/hashInterfaces";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";

interface IDurationAndTimeHelper {
  durationUnitOptionsFor: (values: number | number[]) => IDefaultVOption<number>[]
  durationUnitShortOptions: IDefaultVOption<number>[],
  durationUnitSlaOptions: IDefaultVOption<number>[],
  durationUnitOptions: IDefaultVOption<number>[],
  durationUnitLongOptions: IDefaultVOption<number>[],
  dayOptions: IDefaultVOption<number>[],
  timeOfDayOptionsByHour: IDefaultVOption<number>[],
  timeAmOrPm: IDefaultVOption<number>[],
  monthOptions: IDefaultVOption<number>[],
  minuteOptions: IDefaultVOption<number>[],
  hoursOfDayOptionsTwelveHour: IDefaultVOption<number>[],
  unitLabels: Hash,
}

const DurationAndTimeHelper: IDurationAndTimeHelper = {
  durationUnitOptionsFor: function (values: number | number[]): IDefaultVOption<DurationUnit>[] {
    return InstanceHelper.toArray(values)
      .map(v => Object.assign({}, this.durationUnitOptions.find(o => o.value === v)));
  },

  durationUnitShortOptions: [
    {label: 'Minutes', value: DurationUnit.minute},
    {label: 'Hours', value: DurationUnit.hour},
    {label: 'Days', value: DurationUnit.day},
  ],

  durationUnitSlaOptions: [
    {label: 'Hours', value: DurationUnit.hour},
    {label: 'Days', value: DurationUnit.day},
  ],

  durationUnitOptions: [
    {label: 'Minutes', value: DurationUnit.minute},
    {label: 'Hours', value: DurationUnit.hour},
    {label: 'Days', value: DurationUnit.day},
    {label: 'Weeks', value: DurationUnit.week},
    {label: 'Months', value: DurationUnit.month},
    {label: 'Years', value: DurationUnit.year}
  ],

  durationUnitLongOptions: [
    {label: 'Days', value: DurationUnit.day},
    {label: 'Weeks', value: DurationUnit.week},
    {label: 'Months', value: DurationUnit.month},
    {label: 'Years', value: DurationUnit.year}
  ],

  dayOptions: [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
    {label: '12', value: 12},
    {label: '13', value: 13},
    {label: '14', value: 14},
    {label: '15', value: 15},
    {label: '16', value: 16},
    {label: '17', value: 17},
    {label: '18', value: 18},
    {label: '19', value: 19},
    {label: '20', value: 20},
    {label: '21', value: 21},
    {label: '22', value: 22},
    {label: '23', value: 23},
    {label: '24', value: 24},
    {label: '25', value: 25},
    {label: '26', value: 26},
    {label: '27', value: 27},
    {label: '28', value: 28},
    {label: '29', value: 29},
    {label: '30', value: 30},
    {label: '31', value: 31},
  ],

  hoursOfDayOptionsTwelveHour: [
    {label: '12', value: 12},
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
  ],

  timeOfDayOptionsByHour: [
    {label: '12:00', value: 12},
    {label: '1:00', value: 1},
    {label: '2:00', value: 2},
    {label: '3:00', value: 3},
    {label: '4:00', value: 4},
    {label: '5:00', value: 5},
    {label: '6:00', value: 6},
    {label: '7:00', value: 7},
    {label: '8:00', value: 8},
    {label: '9:00', value: 9},
    {label: '10:00', value: 10},
    {label: '11:00', value: 11},
  ],

  timeAmOrPm: [
    {label: 'AM', value: AmPm.AM},
    {label: 'PM', value: AmPm.PM}
  ],

  monthOptions: [
    {label: 'January', value: Month.january},
    {label: 'February', value: Month.february},
    {label: 'March', value: Month.march},
    {label: 'April', value: Month.april},
    {label: 'May', value: Month.may},
    {label: 'June', value: Month.june},
    {label: 'July', value: Month.july},
    {label: 'August', value: Month.august},
    {label: 'September', value: Month.september},
    {label: 'October', value: Month.october},
    {label: 'November', value: Month.november},
    {label: 'December', value: Month.december}
  ],

  minuteOptions: [
    {label: '00', value: 0},
    {label: '01', value: 1},
    {label: '02', value: 2},
    {label: '03', value: 3},
    {label: '04', value: 4},
    {label: '05', value: 5},
    {label: '06', value: 6},
    {label: '07', value: 7},
    {label: '08', value: 8},
    {label: '09', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
    {label: '12', value: 12},
    {label: '13', value: 13},
    {label: '14', value: 14},
    {label: '15', value: 15},
    {label: '16', value: 16},
    {label: '17', value: 17},
    {label: '18', value: 18},
    {label: '19', value: 19},
    {label: '20', value: 20},
    {label: '21', value: 21},
    {label: '22', value: 22},
    {label: '23', value: 23},
    {label: '24', value: 24},
    {label: '25', value: 25},
    {label: '26', value: 26},
    {label: '27', value: 27},
    {label: '28', value: 28},
    {label: '29', value: 29},
    {label: '30', value: 30},
    {label: '31', value: 31},
    {label: '32', value: 32},
    {label: '33', value: 33},
    {label: '34', value: 34},
    {label: '35', value: 35},
    {label: '36', value: 36},
    {label: '37', value: 37},
    {label: '38', value: 38},
    {label: '39', value: 39},
    {label: '40', value: 40},
    {label: '41', value: 41},
    {label: '42', value: 42},
    {label: '43', value: 43},
    {label: '44', value: 44},
    {label: '45', value: 45},
    {label: '46', value: 46},
    {label: '47', value: 47},
    {label: '48', value: 48},
    {label: '49', value: 49},
    {label: '50', value: 50},
    {label: '51', value: 51},
    {label: '52', value: 52},
    {label: '53', value: 53},
    {label: '54', value: 54},
    {label: '55', value: 55},
    {label: '56', value: 56},
    {label: '57', value: 57},
    {label: '58', value: 58},
    {label: '59', value: 59},
  ],

  unitLabels: {
    [DurationUnit.minute]: "Minutes",
    [DurationUnit.hour]: "Hours",
    [DurationUnit.day]: "Days",
    [DurationUnit.week]: "Weeks",
    [DurationUnit.month]: "Months",
    [DurationUnit.year]: "Years",
  },
};

export default DurationAndTimeHelper;